import React, { useEffect, useState } from 'react';
import { teamApi } from '../api';
import { Spinner, EmptyState, RoleBadge, Alert } from '../components/ui';

export default function Team() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState('');
  const [search,  setSearch]  = useState('');

  useEffect(() => {
    teamApi.getTeam()
      .then(r => setMembers(r.data.data || []))
      .catch(e => setError(e.response?.data?.message || 'Failed to load team'))
      .finally(() => setLoading(false));
  }, []);

  const filtered = members.filter(m =>
    !search ||
    m.name?.toLowerCase().includes(search.toLowerCase()) ||
    m.employeeId?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ padding: '24px', maxWidth: '640px' }}>
      <h1 style={S.title}>My Team</h1>
      <p style={S.sub}>Colleagues in your department — task details stay private to each person.</p>

      {error && <Alert type="error" message={error} />}

      <input
        placeholder="Search team members..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        style={{ ...S.input, marginTop: '16px', marginBottom: '16px', width: '100%' }}
      />

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
      ) : filtered.length === 0 ? (
        <EmptyState icon="👥" title="No team members found" subtitle={
          search
            ? 'Try a different search.'
            : 'Ask your admin to assign you and colleagues to the same department, or check back after more employees join.'
        } />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {filtered.map(m => (
            <div key={m.id} style={{
              display: 'flex', alignItems: 'center', gap: '12px',
              padding: '14px 16px', background: 'var(--color-surface)',
              borderRadius: 'var(--radius-md)', border: '1px solid var(--color-border)',
              opacity: m.away ? 0.75 : 1,
            }}>
              <div style={{
                width: '40px', height: '40px', borderRadius: '50%', flexShrink: 0,
                background: 'var(--color-primary-lighter)', color: 'var(--color-primary)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '16px', fontWeight: 700,
              }}>{m.name?.[0] || '?'}</div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                  <p style={{ fontWeight: 500, fontSize: '15px' }}>{m.name}</p>
                  <RoleBadge role={m.role} />
                  {m.away && (
                    <span style={{ fontSize: '11px', background: '#FFFBEB', color: '#D69E2E', padding: '2px 8px', borderRadius: '999px', fontWeight: 500 }}>
                      Away{m.awayReturnDate ? ` · returns ${m.awayReturnDate}` : ''}
                    </span>
                  )}
                </div>
                <p style={{ fontSize: '13px', color: 'var(--color-text-muted)', marginTop: '2px' }}>
                  {m.employeeId} · {m.departments?.join(', ') || 'No department'}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const S = {
  title: { fontSize: '22px', fontWeight: 600, color: 'var(--color-primary)', marginBottom: '4px' },
  sub:   { fontSize: '13px', color: 'var(--color-text-muted)' },
  input: { padding: '10px 14px', borderRadius: 'var(--radius-md)', border: '1.5px solid var(--color-border)', fontSize: '14px' },
};
